<template>
    <div class="question-object-phonemic-vowel">
        <span class="question-object-phonemic-vowel__label">SESBİRİM</span>
        <span class="question-object-phonemic-vowel__value">/ {{ phonemicValue }} /</span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            phonemicValue: { type: String, default: 'ü' }
        }
    };
</script>

<style scoped src="@/css/components/question-object-phonemic-vowel.css"></style>